/**
 * 合同管理接口
 */
export default {
  // 合同管理-能力平台
  pes_v1: {
    // mock: true,
    control: '/OSN/api/accounts/v1'
  },
  // 企业实名认证校验
  pes_orgCheckIdentityResultV1: {
    // mock: true,
    control: 'OSN/api/orgCheckIdentityResult/v1'
  },
  // 合同管理-合同节点操作-步骤条
  pes_queryContractNodeOperateRecordList: {
    // mock: true,
    control: 'dyc/contract/queryContractNodeOperateRecordList'
  },
  // 合同管理-合同新增编码生成
  pes_generateCode: {
    // mock: true,
    control: 'dyc/contract/generateCode'
  },
  // 合同管理-与第三方签约信息查询
  pes_getSigningInfo: {
    // mock: true,
    control: 'dyc/saas/common/user/signing'
  },
  // 合同管理-与第三方签约信息查询
  pes_getSigningInfoNew: {
    // mock: true,
    control: 'dyc/saas/common/user/getSigningInfo'
  },
  // 合同管理-供应商物料查询
  pes_queryVendorMdm: {
    // mock: true,
    control: 'dyc/contract/queryVendorMdm'
  },
  // 合同管理-获取法大大实名认证地址
  pes_fddGetAuthPersonUrl: {
    // mock: true,
    control: 'dyc/contract/fddGetAuthPersonUrl'
  },
  // 合同管理-获取e签宝实名认证地址
  pes_indivIdentityUrl: {
    // mock: true,
    control: 'OSN/api/indivIdentityUrl/v1'
  },
  // 合同管理-获取e签宝实名认证地址 企业
  pes_orgIdentityUrl: {
    // mock: true,
    control: 'OSN/api/orgIdentityUrl/v1'
  },
  // 合同管理-是否实名认证
  pes_fddVerify: {
    // mock: true,
    control: 'dyc/contract/fddVerify'
  },
  // 合同管理-发起签章
  pes_fddSignContract: {
    // mock: true,
    control: 'dyc/contract/fddSignContract'
  },
  // 合同管理-条款管理-条款列表查询
  pes_qryTermsList: {
    // mock: true,
    control: 'dyc/contract/queryTermsList'
  },
  // 合同管理-条款管理-条款详情查询
  pes_qryTermsDetail: {
    // mock: true,
    control: 'dyc/contract/queryTermsDetails'
  },
  // 合同管理-条款管理-条款删除
  pes_deleteTerms: {
    // mock: true,
    control: 'dyc/contract/deleteTerms'
  },
  // 合同管理-条款管理-条款新增
  pes_addTerms: {
    // mock: true,
    control: 'dyc/contract/addTerms'
  },
  // 合同管理-流程节点查询
  pes_contractProcNodeQuery: {
    // mock: true,
    control: 'dyc/contract/procNodeQuery'
  },
  // 合同管理-供应商查询
  pes_qryDropDwonListExceptAccess: {
    // mock: true,
    control: 'dyc/common/user/enterprise/qryDropDwonListExceptAccess'
  },
  // 合同管理-审批记录查询
  pes_contractQueryAuditLog: {
    // mock: true,
    control: 'dyc/contract/queryAuditLog'
  },
  // 合同管理-条款管理-条款修改
  pes_updateTerms: {
    // mock: true,
    control: 'dyc/contract/updateTerms'
  },
  // 合同管理-条款管理-合同条款变量查询
  pes_qryTermVars: {
    // mock: true,
    control: 'dyc/contract/queryTermsVarsList'
  },
  // 合同管理-模板管理-合同模板列表查询
  pes_queryTemplateList: {
    // mock: true,
    control: 'dyc/contract/queryTemplateList'
  },
  // 合同管理-模板管理-合同模板适用单位列表查询
  pes_queryTemplateApplyOrgList: {
    // mock: true,
    control: 'dyc/contract/queryTemplateApplyOrgList'
  },
  // 合同管理-模板管理-合同模板详情查询
  pes_queryTemplateDetails: {
    // mock: true,
    control: 'dyc/contract/queryTemplateDetails'
  },
  // 订单选择列表查询API(用于合同关联订单查询)
  pes_orderChooseList: {
    // mock: true,
    control: 'dyc/busicommon/order/orderChooseList'
  },
  // 合同管理-模板管理-合同模板删除
  pes_deleteTemplate: {
    // mock: true,
    control: 'dyc/contract/deleteTemplate'
  },
  // 合同管理-模板管理-合同模板复制
  pes_copyTemplate: {
    // mock: true,
    control: 'dyc/contract/copyTemplate'
  },
  // 合同管理-模板管理-合同模板新增
  pes_addTemplate: {
    // mock: true,
    control: 'dyc/contract/addTemplate'
  },
  // 合同管理-模板管理-合同模板修改
  pes_updateTemplate: {
    // mock: true,
    control: 'dyc/contract/updateTemplate'
  },
  // 合同管理-订单合同管理-订单合同列表查询
  pes_queryOrderContractList: {
    // mock: true,
    control: 'dyc/contract/queryOrderContractList'
  },
  // 合同管理-订单合同管理-订单合同删除
  pes_deleteContract: {
    // mock: true,
    control: 'dyc/contract/deleteContract'
  },
  // 合同管理-入驻合同管理-签章
  pes_dealContractSign: {
    // mock: true,
    control: 'dyc/contract/signContract'
  },
  // 合同管理-订单合同管理-订单合同发起签章
  pes_dealSendSign: {
    // mock: true,
    control: 'dyc/contract/dealSendSign'
  },
  // 合同管理-订单合同签订列表
  pes_queryOrderContractSignList: {
    // mock: true,
    control: 'dyc/contract/queryOrderContractSignList'
  },
  // 合同管理-订单合同管理-订单合同废止
  pes_abolishContract: {
    // mock: true,
    control: 'dyc/contract/abolishContract'
  },
  // 合同管理-订单合同管理-订单合同模板下拉框查询
  pes_queryTemplateDropDown: {
    // mock: true,
    control: 'dyc/contract/queryTemplateDropDown'
  },
  // 合同管理-订单合同管理-订单合同模板下拉框查询
  pes_queryTermDropDown: {
    // mock: true,
    control: 'dyc/contract/queryTermDropDown'
  },
  // 合同管理-订单合同管理-订单合同模板下拉框查询
  pes_queryOrderContractItemList: {
    // mock: true,
    control: 'dyc/contract/queryOrderContractItemList'
  },
  // 合同管理-订单合同管理-订单合同保存/提交
  pes_saveOrSubmitOrderContract: {
    // mock: true,
    control: 'dyc/contract/saveOrSubmitOrderContract'
  },
  // 合同管理-订单合同管理-订单合同保存/提交
  pes_queryOrderContractDetails: {
    // mock: true,
    control: 'dyc/contract/queryOrderContractDetails'
  },
  // 合同管理-模板管理-适用单位查询
  common_queryEnterpriseOrgTree: {
    // mock: true,
    control: 'dyc/saas/common/user/org/queryEnterpriseOrgTree'
  },
  // 合同管理-模板管理-适用选择
  common_chooseTemplateApplyOrg: {
    // mock: true,
    control: 'dyc/contract/chooseTemplateApplyOrg'
  },
  // 合同管理-订单合同管理-合同版本列表查询
  pes_queryContractVersionList: {
    // mock: true,
    control: 'dyc/contract/queryContractVersionList'
  },
  // 合同管理-协议合同管理-协议合同审批列表查询
  pes_queryAgreeContractApprovalList: {
    // mock: true,
    control: 'dyc/contract/queryAgreeContractApprovalList'
  },
  // 合同管理-订单合同管理-合同审批记录列表查询
  pes_queryContractApprovalRecordList: {
    // mock: true,
    control: 'dyc/contract/queryContractApprovalRecordList'
  },
  // 合同管理-协议合同管理-协议合同待变更列表查询
  pes_queryAgreeContractPendingChangeList: {
    // mock: true,
    control: 'dyc/contract/queryAgreeContractPendingChangeList'
  },
  // 合同管理-协议合同管理-合同变更申请审批列表
  pes_queryContractChangeApplyApprovalList: {
    // mock: true,
    control: 'dyc/contract/queryContractChangeApplyApprovalList'
  },
  // 合同管理-订单合同管理-订单合同待变更列表查询
  pes_queryOrderContractPendingChangeList: {
    // mock: true,
    control: 'dyc/contract/queryOrderContractPendingChangeList'
  },
  // 合同管理-订单合同管理-合同变更审批
  pes_approvalContractModifyApply: {
    // mock: true,
    control: 'dyc/contract/approvalContractModifyApply'
  },
  // 合同管理-订单合同管理-合同变更申请列表查询
  pes_queryContractChangeApplyList: {
    // mock: true,
    control: 'dyc/contract/queryContractChangeApplyList'
  },
  // 合同管理-入驻合同管理-合同变更列表查询
  pes_queryEnterContractPendingChangeList: {
    // mock: true,
    control: 'dyc/contract/queryEnterContractPendingChangeList'
  },
  // 查询订单详情信息
  pes_queryOrderItemInfoPage: {
    // mock: true,
    control: 'dyc/busicommon/order/queryOrderItemInfoPage'
  },
  // 合同管理-合同应用-合同签章API
  pes_signContract: {
    // mock: true,
    control: 'dyc/contract/signContract'
  },
  // 合同管理-订单合同管理-合同变更申请删除
  pes_deleteContractModifyApply: {
    // mock: true,
    control: 'dyc/contract/deleteContractModifyApply'
  },
  // 合同管理-订单合同管理-合同变更申请删除
  pes_saveOrSubmitOrderContractModifyApply: {
    // mock: true,
    control: 'dyc/contract/saveOrSubmitOrderContractModifyApply'
  },
  // 合同管理-订单合同管理-订单合同变更申请详请
  pes_queryOrderContractChangeApplyDetails: {
    // mock: true,
    control: 'dyc/contract/queryOrderContractChangeApplyDetails'
  },
  // 合同管理-单位协议合同管理-合同列表页页签查询
  pes_queryContractListTabAmount: {
    // mock: true,
    control: 'dyc/contract/queryContractListTabAmount'
  },
  // 合同管理-单位协议合同管理-协议合同列表查询
  pes_queryAgreeContractList: {
    // mock: true,
    control: 'dyc/contract/queryAgreeContractList'
  },
  // 合同管理-单位协议合同管理-协议合同签订列表查询
  pes_queryAgreeContractSignList: {
    // mock: true,
    control: 'dyc/contract/queryAgreeContractSignList'
  },
  // 合同管理-单位协议合同管理-协议合同保存提交
  pes_saveOrSubmitAgreeContract: {
    // mock: true,
    control: 'dyc/contract/saveOrSubmitAgreeContract'
  },
  // 合同管理-单位协议合同管理-无源协议合同明细导入
  pes_importNoSourceAgreeContractItem: {
    // mock: true,
    control: 'dyc/contract/importNoSourceAgreeContractItem'
  },
  // 合同管理-单位协议合同管理-无源协议合同明细导入
  pes_queryAgreeContractDetails: {
    // mock: true,
    control: 'dyc/contract/queryAgreeContractDetails'
  },
  // 合同管理-单位协议合同管理-协议合同明细列表查询
  pes_queryAgreeContractItemList: {
    // mock: true,
    control: 'dyc/contract/queryAgreeContractItemList'
  },
  // 合同管理-单位协议合同管理-协议合同变更申请详情查询
  pes_queryAgreeContractChangeApplyDetails: {
    // mock: true,
    control: 'dyc/contract/queryAgreeContractChangeApplyDetails'
  },
  // 合同审批管理  订单合同审批列表查询API
  pes_queryOrderContractApprovalList: {
    // mock: true,
    control: 'dyc/contract/queryOrderContractApprovalList'
  },
  // 合同管理-单位协议合同管理-协议合同变更申请保存提交
  pes_saveOrSubmitAgreeContractModifyApply: {
    // mock: true,
    control: 'dyc/contract/saveOrSubmitAgreeContractModifyApply'
  },
  // 合同管理-内部单位协议合同管理-入驻合同列表查询
  pes_queryEnterContractList: {
    // mock: true,
    control: 'dyc/contract/queryEnterContractList'
  },
  // 合同管理-内部单位协议合同管理-入驻合同保存提交
  pes_saveOrSubmitEnterContract: {
    // mock: true,
    control: 'dyc/contract/saveOrSubmitEnterContract'
  },
  // 合同管理-内部单位协议合同管理-入驻合同签订
  pes_queryEnterContractSignList: {
    // mock: true,
    control: 'dyc/contract/queryEnterContractSignList'
  },
  // 合同管理-内部单位协议合同管理-入驻合同详情查询
  pes_queryEnterContractDetails: {
    // mock: true,
    control: 'dyc/contract/queryEnterContractDetails'
  },
  // 合同管理-内部单位协议合同管理-合同供应商销售品类列表查询
  pes_querySupplierSaleCategoryList: {
    // mock: true,
    control: 'dyc/contract/querySupplierSaleCategoryList'
  },
  // 合同管理-内部单位协议合同管理-合同供应商年终阶梯费率列表查询
  pes_querySupplierLadderRateList: {
    // mock: true,
    control: 'dyc/contract/querySupplierLadderRateList'
  },
  // 合同管理-内部单位协议合同管理-入驻合同变更申请保存提交
  pes_saveOrSubmitEnterContractModifyApply: {
    // mock: true,
    control: 'dyc/contract/saveOrSubmitEnterContractModifyApply'
  },
  // 合同管理-内部单位协议合同管理-入驻合同变更申请详情查询
  pes_queryEnterContractChangeApplyDetails: {
    // mock: true,
    control: 'dyc/contract/queryEnterContractChangeApplyDetails'
  },
  // 合同管理-内部单位协议合同管理-入驻合同变更申请详情查询
  pes_getSupplierContractList: {
    // mock: true,
    control: 'dyc/saas/supplier/getSupplierContractList'
  },
  // 合同管理-入驻合同管理-合同审批
  pes_approvalContract: {
    // mock: true,
    control: 'dyc/contract/approvalContract'
  },
  // 合同管理-合同审批列表页签数量查询API
  pes_queryContractApprovalListTabAmount: {
    // mock: true,
    control: 'dyc/contract/queryContractApprovalListTabAmount'
  },
  // 合同管理-合同审批列表页-入驻合同审批列表查询
  pes_queryEnterContractApprovalList: {
    // mock: true,
    control: 'dyc/contract/queryEnterContractApprovalList'
  },
  // 合同应用-合同变更申请审批列表页签数量查询API
  pes_queryContractModifyApplyApprovalListTabAmount: {
    // mock: true,
    control: 'dyc/contract/queryContractModifyApplyApprovalListTabAmount'
  },
  // 我的首页-公用应用-合同变更详情
  common_getSignContractApplyDetail: {
    // mock: true,
    control: 'dyc/saas/supplier/getSignContractApplyDetail'
  },
  // 合同管理-供应商签约单品类列表查询API
  dyc_getSignContractApplyDetail: {
    // mock: true,
    control: 'dyc/saas/supplier/getSignContractApplyDetail'
  },
  // 电子合同-合同管理列表查询
  dyc_qryContractManageInfoPageList: {
    // mock: true,
    control: 'dyc/saas/self/order/qryContractManageInfoPageList'
  },
  // 电子合同-操作记录查询
  dyc_qryContractManageInfo: {
    // mock: true,
    control: 'dyc/saas/self/order/qryContractManageInfo'
  },
  // 电子合同-下载合同
  dyc_qryContractAttachmentUrl: {
    // mock: true,
    control: 'dyc/saas/self/order/qryContractAttachmentUrl'
  },
  // 电子合同-取消合同
  dyc_cancelContract: {
    // mock: true,
    control: 'dyc/saas/self/order/cancelContract'
  },
  // 电子合同-归档合同
  dyc_saveFileContract: {
    // mock: true,
    control: 'dyc/saas/self/order/saveFileContract'
  },
  // 电子合同-拒签合同
  dyc_saveRefuseSignContract: {
    // mock: true,
    control: 'dyc/saas/self/order/saveRefuseSignContract'
  },
  // 电子合同-重新发送合同
  dyc_initiateSigning: {
    // mock: true,
    control: 'dyc/saas/self/order/initiateSigning'
  }
};